import { reduce } from "et3-type-guards";

import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import { getPermissionIDRequired } from "../../../helpers/et3-has-permission";
import getCorePersonalStore from "../../../stores/core/core-personal-store";

import { TSubMenuDropDownProps } from "../../../Types";
import SubMenuDropDownItem from "./SubMenuDropDownItem";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3Div from "../../../core/et3-div";

const SubMenuDropDown = withLiteObserverAndTheme<TSubMenuDropDownProps>(
  (props) => {
    const { options, theme } = props;
    const { colors } = theme;
    const userPermissions = getCorePersonalStore().userPermissions.get();
    const items = options.map((option) => {
      const name = reduce(() => option.name, "");
      const pageName = reduce(() => option.pageName, "");
      const pageSubName = reduce(() => option.pageSubName, "");
      const visible = reduce(
        () =>
          userPermissions.indexOf(getPermissionIDRequired(name)) > -1 &&
          option.visibility,
        false
      );
      const isSelected = getCoreHistoryStore().getPageName() === pageName;
      const isSubTabSelected =
        getCoreHistoryStore().getPageSubName() === pageSubName;
      return (
        <SubMenuDropDownItem
          isSelected={isSelected && isSubTabSelected}
          visible={visible}
          option={option}
          key={option.name}
        />
      );
    });

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={250}
        height={50}
        fDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        {items}
      </ET3Div>
    );
  }
);
export default SubMenuDropDown;
